var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('draggable',{attrs:{"value":_vm.value,"move":_vm.dragMove},on:{"input":function($event){return _vm.$emit('input', $event)},"end":_vm.dragEnd}},[_vm._t("default",null,{"draggingId":_vm.draggingId,"list":_vm.value})],2)}
var staticRenderFns = []

export { render, staticRenderFns }